import './TeamAssignment.scss';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {resetStateTeamAssignment, setHistoryLoading, setTeamAssignmentLoading} from '../../stores/actions/teamAssignmentAction';
import {
  getAvailableEmployee,
  initializeTeamAssignment,
  selectProject,
} from '../../stores/business/teamAssignmentBusiness';
import {setSelectedProject} from '../../stores/actions/teamAssignmentAction';
import {selectProjects, userAndProjectSelector} from '../../stores/selectors/teamAssignmentSelector';
import {FmlxComboBox} from 'fmlx-common-ui';
import AddMemberControls from '../Assignment/componentTeamAssignment/AddMemberControl';
import FmlxBackdropLoading from '../../components/BackdropLoading/BackdropLoading';
import ModalNoAccess from '../Assignment/componentTeamAssignment/ModalNoAccess';
import ModalJoinDate from '../Assignment/componentTeamAssignment/ModalJoinDate';
import ModalOutDate from '../Assignment/componentTeamAssignment/ModalOutDate';
import projectBusiness from '../../stores/business/projectBusiness';
import TableTeamAssignment from '../Assignment/componentTeamAssignment/TableTeamAssignment';
import TeamMemberHistory from '../Assignment/componentTeamAssignment/TeamMemberHistory';

function TeamAssignment() {
  const dispatch = useDispatch();
  const {user, selectedProject} = useSelector(userAndProjectSelector);
  const listProject = useSelector(selectProjects);
  const [isLoading, setIsLoading] = useState(true);
  const [showNoAccessModal, setShowNoAccessModal] = useState(false);

  useEffect(() => {
    if (user) {
      const fetchData = async () => {
        setIsLoading(true);
        await dispatch(getAvailableEmployee());
        await dispatch(initializeTeamAssignment());
        await dispatch(projectBusiness.fetchProjectLeads());
        setIsLoading(false);
      };

      fetchData();
      setShowNoAccessModal(!selectedProject);
    }
    return () => {
      dispatch(resetStateTeamAssignment());
    };
  }, []);

  useEffect(() => {
    if (selectedProject && selectedProject.id) {
      dispatch(setTeamAssignmentLoading(true))
      dispatch(setHistoryLoading(true));
      dispatch(selectProject(selectedProject));
    }
  }, [selectedProject, dispatch]);

  const handleCloseNoAccessModal = () => {
    setShowNoAccessModal(false);
  };

  return (
    <>
      {isLoading ? (
        <div className="center">
          <FmlxBackdropLoading show description={null} showButton={false} />
        </div>
      ) : (
        <div className="team-assignment-container">
          <h3>TEAM ASSIGNMENT</h3>
          <div className="project-selector-container">
            <FmlxComboBox
              id="projectDropdown"
              placeholder={selectedProject ? selectedProject.text : 'Select Project'}
              items={listProject}
              selectedItem={listProject.find((item) => item.data.id === selectedProject?.id)}
              loading={listProject.length === 0}
              onChange={(item) => dispatch(setSelectedProject(item.data))}
            />
          </div>
          <TableTeamAssignment />
          <AddMemberControls />
          <TeamMemberHistory />
          <ModalNoAccess open={showNoAccessModal} onCloseClick={handleCloseNoAccessModal} />
          <ModalJoinDate />
          <ModalOutDate />
        </div>
      )}
    </>
  );
}

export default TeamAssignment;
